/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FloatBottom.css';
import cx from 'classnames'
import history from '../../history'
import moment from 'moment'
import Model from '../Model'


class FloatBottom extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      isShowModel:false
    
    }
    this.closeModel=this.closeModel.bind(this)
 
  }
  
  closeModel=()=>{
    this.setState({
      isShowModel:false
    })
    this.props.close()
  }

  render() {
    const  {isShowModel}=this.state
    
   
    return (
      <div className={this.props.show?s.root:s.hide}>
        <div className={s.root}>

          <div className={cx(s.floatLogin,s.floatSmall)} >
            <div className={s.flTxt} >
              <span className={s.flSpan}>您享有的免费试用期已经到期，成为正式付费用户，享有更多权益和服务！</span>
              {/* <a href="javascript:;" className={s.showBtn} onClick={()=>{
                console.log('记录')
                this.props.close()
                }}>Yes</a>
              <a href="javascript:;" className={s.showBtn} onClick={()=>{
                console.log('不记录')
                this.props.close()
              }}>No</a> */}
              <div className={s.showBtn} onClick={()=>{
                this.setState({isShowModel:true})
                {/* this.props.close() */}
              }}>成为正式用户</div>
            </div>
            <div className={s.close} onClick={this.props.close}></div>
            
              
          </div>
          <Model  isShow={isShowModel} close={this.closeModel} />
        </div>
      </div>
    )



  }
}

export default withStyles(s)(FloatBottom);



// WEBPACK FOOTER //
// src/components/FloatBottom/FloatBottom.js